import { capitalize } from './strings';

export const getShortUserName = (userName) => {
    const parts = String(userName)
        .trim()
        .split(' ');
    return parts.length > 1 ? `${capitalize(parts[1] ?? '')} ${capitalize(parts[0]?.charAt(0) ?? '')}.` : parts[0];
};

export const getShortUserNameWithChecks = (userName) => {
    const parts = String(userName)
        .trim()
        .split(' ');
    if (parts.length < 2) {
        return userName;
    }

    if (parts[1].length <= 2 || parts[1].charAt(2) === '.') {
        return userName;
    }

    return `${parts[1]} ${parts[0].charAt(0)}.`;
};

export const isAddChild = (fields) => {
    console.log('[isAddChild]', fields);
    const filteredFields = fields?.filter?.(f => f?.startsWith?.('family.['))?.map?.((f) => String(f).substring(11))?.map?.(f=>f?.substring(0) === ']' ? f?.substring(1):f)?.filter?.(Boolean);
    console.log('isAddChild', filteredFields);
    const neededField = ['profileId', 'relKind'];
    return neededField.every((nf) => filteredFields?.includes(nf));
}

export const profileChangedFieldsList = (fields) => {
    return fields?.filter?.(f => !f?.startsWith?.('keys.['));
}

export const isProfileUpdate = (fields) => {
    const updated = profileChangedFieldsList(fields);
    const fieldsForChange = ['sex',
        'fullNameRu',
        'birthday',
        'phones'];
    return fieldsForChange.some((f) => updated?.includes?.(f) || updated?.some?.(u => u?.startsWith?.(f + '.')));
}

export const isProfileFill = (fields) => {
    const updated = profileChangedFieldsList(fields);
    const fieldsForChange = ['sex',
        'fullNameRu',
        'birthday'];
    return fieldsForChange.every((f) => updated?.includes?.(f));
}

export const profileIsEmailConfirmed = (fields) => {
    const updated = profileChangedFieldsList(fields);
    return updated?.every?.(f => f?.startsWith('emails'));
}

export const isConsentsOnly = (fields) => {
    const updated = profileChangedFieldsList(fields);
    return updated?.every?.(f => f?.startsWith('consent') || f?.startsWith('cards'));
}

export const isGrantsChanged = (fields) => {
    return profileChangedFieldsList(fields)?.some?.(f => f?.startsWith?.('grants'));
}
